import { Box, FormControl, InputAdornment, TextField, TextFieldProps } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { BiSearch } from 'react-icons/bi'

export type ISearchInputProps = TextFieldProps

export default function SearchInput(props: ISearchInputProps) {
  const { t } = useTranslation()

  return (
    <Box>
      <FormControl sx={{ width: '100%' }}>
        <TextField
          sx={{
            p: 0,
            m: 0,
            color: 'button.color',
            backgroundColor: 'button.background',
            borderRadius: '4px',
            border: 'none',
            '& fieldset': { border: 'none' },
          }}
          variant="outlined"
          placeholder={t('Search')}
          InputProps={{
            sx: {
              pl: 0,
              pr: '12px',
              color: 'button.color',
              border: 'none',
            },
            inputProps: {
              sx: {
                fontSize: '15px',
                padding: '7px 0px 7px 10px',
              },
            },
            startAdornment: (
              <InputAdornment position="end">
                <Box aria-label="Toggle password visibility" sx={{ fontSize: '24px', color: 'button.color' }}>
                  <BiSearch />
                </Box>
              </InputAdornment>
            ),
          }}
          {...props}
        />
      </FormControl>
    </Box>
  )
}
